import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  imports: [NgStyle],
})
export class IconComponent {
  @Input({ required: true }) public src!: string;
  @Input() public alt?: string;
}
